export const monarchReceiptOfRemains = {
  id: "monarch-receipt-of-remains-2026-07-08",
  title: "Receipt of Death Certificates/Cremated Remains",
  sourceTitle: "RECIEPT OF DEATH CERTIFICATES/CREMATED REMAINS",
  sourceFile: "docs/forms/monarch-receipt-of-remains-karen-2026-07-08.pdf",
  sourceAttachmentName: "Receipt of Remains-DCS-2.pdf",
  versionLabel: "Karen form received July 8, 2026",
  pages: 1,
  status: "ready_for_template_formatting",
  everyFamilySigns: true,
  requiredFields: [
    "Loved One's Name",
    "Team Member",
    "Name and Relationship of Recipient",
    "Number of Certificates Received: With Cause",
    "Number of Certificates Received: Without Cause",
    "Description of Urn",
    "Authorized person signature",
    "Date signed",
  ],
  certificateCounts: ["With Cause", "Without Cause"],
  releaseText:
    "I hereby represent that I am the legally authorized person to accept the cremated remains of the Loved One above and hereby terminate the liability and custodial care of Monarch Funeral Home and Cremation Services.",
  staffUseCases: [
    "Record death certificate pickup or delivery.",
    "Record cremated-remains release to an authorized recipient.",
    "Close the final custody handoff task for the case.",
  ],
  signatureBlocks: [
    {
      title: "Authorized Person",
      fields: ["Signature", "Date"],
    },
    {
      title: "Authorized Person",
      fields: ["Signature", "Date"],
    },
  ],
  footer: {
    funeralHome: "Monarch Funeral Home and Cremation Services",
    address: "2950 N. State Road 7 | Margate, FL 33063",
    website: "MonarchFuneralHome.com",
  },
} as const;
